import React, { useMemo } from 'react';
import { Prompt } from 'react-router-dom';

import { Box, ReactDataTable, Alert, Typography } from '@metarouter-private/mr-mui';

import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import { useBulkDeployPageContext } from '../BulkDeployPageContext';
import BulkDeployTableTitle from './BulkDeployTableTitle';
import useBulkDeployTable from './useBulkDeployTable';
import buildBulkDeployTableColumns from './buildBulkDeployTableColumns';

export default function BulkDeployTable() {
  const { isDeploying } = useBulkDeployPageContext();
  const { pipelineTagsMvpEnabled } = useFeatureEnabled(FEATURE_FLAGS.pipelineTagsMvp);

  const tableProps = useBulkDeployTable();
  const columns = useMemo(
    () => buildBulkDeployTableColumns({ showTags: pipelineTagsMvpEnabled }),
    [pipelineTagsMvpEnabled]
  );

  return (
    <Box>
      <Alert variant="filled" severity="info">
        <ul>
          <li>
            <Typography variant="subtitle1">- Only pipelines with staged changes will apear here.</Typography>
          </li>

          <li>
            <Typography variant="subtitle1">
              - Navigating away during deployment can interrupt the deployment process.
            </Typography>
          </li>
        </ul>
      </Alert>

      <Box mt={2} data-test-id="bulkDeployTable">
        <ReactDataTable title={<BulkDeployTableTitle />} columns={columns} {...tableProps} />
      </Box>

      <Prompt
        when={isDeploying}
        message="Leaving this page may interrupt your deployment. Are you sure you want to leave?"
      />
    </Box>
  );
}
